import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Priya Patel",
      treatment: "Skin Glow Treatment",
      rating: 5,
      text: "I've been coming to Dr Vaibhav Moghariya Clinic for over a year now, and the results have been amazing! The Botox treatments are so natural-looking, and Dr. Emily is incredibly skilled. The staff is professional and the clinic is spotless.",
      image: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    {
      id: 2,
      name: "Kiran Shah",
      treatment: "Laser Hair Removal",
      rating: 5,
      text: "After years of dealing with unwanted hair, I finally found the perfect solution at Dr Vaibhav Moghariya Clinic. The laser hair removal process was virtually painless, and the results are permanent. Highly recommend!",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80"
    },
    {
      id: 3,
      name: "Ritu Joshi",
      treatment: "Acne Treatment",
      rating: 5,
      text: "I struggled with acne for years and tried everything. The acne treatment program at Dr Vaibhav Moghariya Clinic finally gave me the clear skin I've always wanted. The team is so supportive and knowledgeable.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80"
    },
    {
      id: 4,
      name: "Hardik Desai",
      treatment: "Hair PRP Treatment",
      rating: 5,
      text: "The hair fall control treatment has been life-changing. I was losing confidence along with my hair, but the team at Dr Vaibhav Moghariya Clinic helped me regain both. The PRP therapy really works!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80"
    },
    {
      id: 5,
      name: "Meera Trivedi",
      treatment: "Chemical Peel",
      rating: 5,
      text: "The chemical peels have transformed my skin completely. My skin tone is even, and I look years younger. The consultation process was thorough, and they explained everything perfectly.",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80"
    },
    {
      id: 6,
      name: "Rajesh Vora",
      treatment: "Anti-Aging Treatment",
      rating: 5,
      text: "As a busy executive, I needed a solution that would give me results without downtime. The anti-aging facials at Dr Vaibhav Moghariya Clinic are perfect. I look refreshed and professional after every session.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80"
    }
  ];

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, i) => (
      <span key={i} className="star">⭐</span>
    ));
  };

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">
            Don't just take our word for it. Hear from our satisfied clients about their transformative experiences.
          </p>
        </motion.div>

        <motion.div
          className="testimonials-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, transition: { staggerChildren: 0.1 } }}
          viewport={{ once: true }}
        >
          {testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="testimonial-header">
                <img src={testimonial.image} alt={testimonial.name} className="testimonial-avatar" />
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-treatment">{testimonial.treatment}</p>
                  <div className="testimonial-rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="testimonials-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <h3>Ready to Start Your Journey?</h3>
          <p>Join thousands of satisfied clients who have transformed their skin with our expert care.</p>
          <button className="btn-primary">Book Your Consultation</button>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
